import type { User } from '@/types/auth';

/** Rollen SYS_ADMIN — inte is_global_admin (fler Deviaq-användare har den flaggan). */
export function isSysAdminUser(user: User | null | undefined): boolean {
  if (!user) return false;
  const codes = Array.isArray(user.roleCodes) ? user.roleCodes : [];
  if (codes.some((code) => String(code).trim().toUpperCase() === 'SYS_ADMIN')) {
    return true;
  }
  return String(user.role || '').trim().toUpperCase() === 'SYS_ADMIN';
}
